import React from 'react';
import { Fragment, useEffect, useState } from "react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import { Listbox, Transition } from "@headlessui/react";
import * as Icon from "react-bootstrap-icons";
import { StarFill } from "react-bootstrap-icons";
import TabCalender from "../TabCalender";
import { fetchEventDetail, submitEventData } from '../../redux/actions/settingActions';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { DateRange } from "react-date-range";

const duration = [
  { id: 1, name: "15 Min", value:"900" },
  { id: 2, name: "30 Min", value:"1800" },
  { id: 3, name: "45 Min", value:"2700" },
  { id: 4, name: "60 Min", value:"3600" },
];

const schedule_within = [
  { id: 1, name: "Minutes", value:"0" },
  { id: 2, name: "Hours", value:"1" },
];

const date_range_schedule = [
  { id: 1, name: "Calendar Days", value: 0, sub_text:"Counts every day on the calendar including days you're unavailable" },
  { id: 2, name: "Weekdays", value: 1, sub_text:"Excludes weekends and only counts Mon - Fri" },
];

const before_after_time = [
  { id: 1, name: "5 Min", value:"300" },
  { id: 2, name: "10 Min", value:"600" },
  { id: 3, name: "15 Min", value:"900" },
  { id: 4, name: "20 Min", value: "1200" },
  { id: 1, name: "25 Min", value:"1500" },
  { id: 2, name: "30 Min", value:"1800" },
];

const start_increment = [
  { id: 1, name: "5 Min", value:"300" },
  { id: 2, name: "10 Min", value:"600" },
  { id: 3, name: "15 Min", value:"900" },
  { id: 4, name: "20 Min", value: "1200" },
  { id: 1, name: "25 Min", value:"1500" },
  { id: 2, name: "30 Min", value: "1800" },
  { id: 4, name: "35 Min", value: "2100" },
  { id: 1, name: "40 Min", value:"2400" },
  { id: 2, name: "45 Min", value:"2700" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const SettingEvents = (props) => {
  const { id } = useParams();
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const moment = require('moment');
  const dispatch = useDispatch();
  const authToken = props.authToken;
  const [tabName, setTabName] = useState("Schedules");
  const tabs = [
      { name: "Connect", href: "/Setting/connect", current: false },
      { name: "Schedules", href: "/Setting/calender", current: false },
      { name: "Events", href: "/Setting/events", current: true },
  ];
  const [rangeString, setRangeString] = useState("all");
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const eventDetail = useSelector((state) => state.setting.fetchEventDetail);
  const schedule_list = useSelector((state) => state.setting.fetchScheduleList);
  const [allowedEvent, setAllowedEvent] = useState("");
  const [durationData , setDurationData] = useState(null);
  const [beforeTime , setBeforeTime] = useState(null);
  const [afterTime , setAfterTime] = useState(null);
  const [scheduleData , setScheduleData] = useState(null);
  const [dateRangeCheck , setDateRangeCheck] = useState(null);
  const [incrementTime , setIncrementTime] = useState(null);
  const [scheduleTimeLimit , setScheduleTimeLimit] = useState(null);
  const [dateRangeFirst , setDateRangeFirst] = useState(null);
  const [dateRangeFirstInput , setDateRangeFirstInput] = useState(null);
  const [scheduleTimeLimitInput , setScheduleTimeLimitInput] = useState("");

  useEffect(() => {
    if (id !== undefined) {
      dispatch(fetchEventDetail(authToken, id));
    }
  }, [])
  
  useEffect(() => {
    if (eventDetail && Object.keys(eventDetail)?.length > 0) {
      let dataDuration = duration.filter((item) => item.value == eventDetail?.duration);
      let dataBeforeEvent = before_after_time.filter((item) => item.value == eventDetail?.before_add_time);
      let dataAfterEvent = before_after_time.filter((item) => item.value == eventDetail?.after_add_time);
      let dataIncrement = start_increment.filter((item) => item.value == eventDetail?.start_time_increment);
      let dataSchedule = schedule_list.filter((item) => item.schedule_id == eventDetail?.schedule_id);
      let dataScheduleWithin = schedule_within.filter((item) => item.value == eventDetail?.schedule_start_type);
      let dateRangeWithin = date_range_schedule.filter((item) => item.value == eventDetail?.meta_data?.range_type);
      
      setDurationData(dataDuration[0]);
      setBeforeTime(dataBeforeEvent[0]);
      setAfterTime(dataAfterEvent[0]);
      setIncrementTime(dataIncrement[0]);
      setScheduleData(dataSchedule[0]);
      setDateRangeFirst(dateRangeWithin[0] || { id: 1, name: "Calendar Days", value: 0, sub_text:"Counts every day on the calendar including days you're unavailable" });
      setScheduleTimeLimit(dataScheduleWithin[0]);
      setDateRangeCheck(eventDetail?.date_range_type);
      setDateRangeFirstInput(eventDetail?.meta_data?.range_no);
      setScheduleTimeLimitInput(eventDetail?.schedule_start);
      setAllowedEvent(eventDetail?.max_event);
      setDateRange(
        {
          startDate: eventDetail?.meta_data?.from_date || null ,
          endDate: eventDetail?.meta_data?.to_date || null ,
          key: 'selection',
        }
      );
      setRangeString("calendar")
    }
  }, [eventDetail])
  
  const handleCalendar = (ranges) => {
    setShowCalendar(false)
    const { startDate, endDate } = selectedDates[0];
    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    const formattedRange = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    setDateRange(formattedRange);
    
  };
  
  const filteredDuration =
    query === ""
      ? duration
      : duration.filter((duration_single) => {
          return duration_single.name.toLowerCase().includes(query.toLowerCase());
      });
  
  const filteredScheduleWithin =
    query === ""
      ? schedule_within
      : schedule_within.filter((schedule) => {
          return schedule.name.toLowerCase().includes(query.toLowerCase());
      });
  
  const filteredBeforeAfterTime =
    query === ""
      ? before_after_time
      : before_after_time.filter((time) => {
          return time.name.toLowerCase().includes(query.toLowerCase());
      });
  
  const filteredStartIncrement =
    query === ""
      ? start_increment
      : start_increment.filter((inc) => {
          return inc.name.toLowerCase().includes(query.toLowerCase());
      });
  
  const filteredScheduleList =
    query === ""
      ? schedule_list
      : schedule_list.filter((schedule) => {
          return schedule.name.toLowerCase().includes(query.toLowerCase());
      });
  
  const filteredDateRange =
    query === ""
      ? date_range_schedule
      : date_range_schedule.filter((schedule) => {
          return schedule.name.toLowerCase().includes(query.toLowerCase());
      }); 
  
  const handleEventSubmit = () => {
    let date_range_structure;
    if (dateRangeCheck === "0") {
      date_range_structure = {
        range_no: dateRangeFirstInput,
        range_type: dateRangeFirst?.value
      }
    } else if (dateRangeCheck === "1") {
      date_range_structure = {
        from_date: dateRange?.startDate,
        to_date: dateRange?.endDate
      }
    } else {
      date_range_structure = null
    }
    if (eventDetail?.id !== ""){
      dispatch(submitEventData(authToken, onSuccess, allowedEvent, scheduleTimeLimit, scheduleTimeLimitInput, scheduleData, incrementTime, afterTime, beforeTime, durationData, date_range_structure, dateRangeCheck, id, eventDetail.id))
    } else {
      dispatch(submitEventData(authToken, onSuccess, allowedEvent, scheduleTimeLimit, scheduleTimeLimitInput, scheduleData, incrementTime, afterTime, beforeTime, durationData, date_range_structure, dateRangeCheck, id))
    } 
  }
  
  const onSuccess = () => {
    navigate("/Setting/events");
  }
  
  return (
    <>
      {/* Tabs */}
      <div className="px-6 sm:px-8 mb-4 lg:px-10">
          <TabCalender tabs={tabs} setTabName={setTabName} tabName={tabName} />  
      </div>
      <div className="h-[78vh] overflow-y-auto listing pt-1">
        <div className="px-6 sm:px-8 lg:px-10">
          <div className="bg-white rounded-t-md border border-solid border-[lightgray] border-b-0 px-4 py-3 mt-2">
            <div className="flex justify-between">
                <p className="font-bold text-lg flex items-center">{eventDetail?.event_name} {eventDetail?.status === "1" && <StarFill className="h-5 w-5 ml-2 text-[var(--brand-primary)]" aria-hidden="true" />}</p> 
                <div className="flex items-center">
                    <button
                      onClick={()=>{navigate("/Setting/events")}}
                      type="button"
                      className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent hover:bg-[#bcc2c3] px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
                    >
                      <Icon.ChevronLeft className="text-[#000000]"/> <span>Back</span>
                    </button>
                  <button
                    onClick={handleEventSubmit}
                    type="button"
                    className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
                  >
                    Save Changes
                  </button>              
                </div>  
            </div>
          </div>
          <div className="pb-10 bg-white rounded-b-md border border-solid border-[lightgray] px-4 py-0 pt-4">
          <div className="mt-0 font-bold">Date Range</div>
          <div className="mt-3 grid grid-cols-9">
            <fieldset as="div" className="col-span-3 max-sm:col-span-12">
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-2">Invitees can schedule...</label>
              <div className="space-y-5">
                  <div className="relative flex items-center">
                    <div className="flex h-6 items-center">
                      <input
                        id="1"
                        aria-describedby={`1-description`}
                        name="plan"
                        type="radio"
                        checked={dateRangeCheck === "0"}
                        onChange={(e) => {
                          setDateRangeCheck("0");
                        }}
                        className="h-4 w-4 border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                      />
                    </div>
                    <div className="ml-3 text-sm leading-6 grid grid-cols-12">
                      <div className="mt-2 col-span-4 mr-4">
                        <input
                          type="text"
                          name="time"
                          id="time"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                          placeholder="0 - 300"
                          value={dateRangeFirstInput}
                          onChange={(e) => {
                            if((e.target.value > 0 && e.target.value < 301) || e.target.value === "")
                            setDateRangeFirstInput(e?.target?.value)
                          }}
                          min="1"
                          max="6"
                        />
                      </div>
                      <Listbox as="div" className="col-span-8" value={dateRangeFirst} onChange={setDateRangeFirst}>
                          {({ open }) => (
                            <>
                              <div className="relative mt-2">
                                <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                  <span className="block truncate">{dateRangeFirst?.name}</span>
                                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                    <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                  </span>
                                </Listbox.Button>

                                <Transition
                                  show={open}
                                  as={Fragment}
                                  leave="transition ease-in duration-100"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                                >
                                  <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                    {filteredDateRange?.map((date) => (
                                      <Listbox.Option
                                        key={date.id}
                                        className={({ active }) =>
                                          classNames(
                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                            'relative cursor-default select-none py-2 pl-3 pr-9'
                                          )
                                        }
                                        value={date}
                                      >
                                        {({ selected, active }) => (
                                          <>
                                            <div>
                                              <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                {date.name}
                                              </span>

                                              {selected ? (
                                                <span
                                                  className={classNames(
                                                    active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                    'absolute inset-y-0 right-0 flex items-center pr-4'
                                                  )}
                                                >
                                                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                              ) : null}
                                              <div className='py-1'>
                                                <span className='text-xs'>{date.sub_text}</span>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </Listbox.Option>
                                    ))}
                                  </Listbox.Options>
                                </Transition>
                              </div>
                            </>
                          )}
                      </Listbox>  
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <div className="flex h-6 items-center">
                      <input
                        id="2"
                        aria-describedby={`2-description`}
                        name="plan"
                        type="radio"
                        checked={dateRangeCheck === "1"}
                        onChange={(e) => {
                          setDateRangeCheck("1");
                        }}
                        className="h-4 w-4 border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                      />
                    </div>
                    <div className="ml-3 text-sm leading-2 grid grid-cols-12">
                      <div className="col-span-4 mr-4">
                          Within a date range
                      </div>
                      <div className="col-span-8">
                        {dateRange.endDate !== null && rangeString === "calendar" && <div className={`relative w-full flex items-center rounded-md text-center bg-white py-1.5 pl-3 pr-2 max-sm:pr-3 text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6 bulletTags h-[36px] text-xs max-sm:text-[12px] max-sm:relative max-sm:bottom-0 font-semibold cursor-pointer ${rangeString === "calendar" ? "bulletActive" : ""}`} onClick={() => { setShowCalendar(!showCalendar); setRangeString("calendar") }}>{dateRange?.startDate} / {dateRange?.endDate}</div>}
                          {(selectedDates[0].endDate == null || dateRange.endDate == null) && <div className={`relative w-full items-center text-center cursor-default rounded-md bg-white py-1.5 pl-3 pr-3 text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6 bulletTags text-xs max-sm:text-[12px] font-medium border flex justify-center mr-1 my-auto ${rangeString === "calendar" ? "bulletActive" : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)]"}`} onClick={()=>{setShowCalendar(!showCalendar);setRangeString("calendar");setDateRange({
                              startDate: null,
                              endDate: null,
                            })}}>
                            Choose Time Duration <Icon.CalendarDate className="ml-1 my-auto" />
                          </div>}
                          {showCalendar && <div className="bulletTags bg-[white] right-[-90px] max-sm:right-[-30px] p-2 top-[119%] z-10 border border-gray-400 rounded-lg max-sm:left-[-30px] max-sm:top-full text-xs mr-1 my-auto absolute">
                            <DateRange
                              editableDateInputs={true}
                              onChange={(ranges)=>{setSelectedDates([ranges.selection])}}
                              moveRangeOnFirstSelection={false}
                              ranges={selectedDates}
                              showMonthAndYearPickers={true}
                              showDateDisplay={false}
                              // initialFocusedRange={[17-18]}
                            />
                            <div className="flex w-full p-2">
                              <div className="ms-auto flex">
                                <div className="bg-[var(--brand-primary)] text-center text-[white] px-4 py-2 rounded-[20px] border-[none] cursor-pointer mr-2" onClick={()=>setShowCalendar(false)}>Cancel</div>
                                <div className="bg-[var(--brand-primary)] text-center text-[white] px-4 py-2 rounded-[20px] border-[none] cursor-pointer" onClick={()=>{handleCalendar()}}>OK</div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <div className="flex h-6 items-center">
                      <input
                        id="3"
                        aria-describedby={`3-description`}
                        name="plan"
                        type="radio"
                        checked={dateRangeCheck === "2"}
                        onChange={(e) => {
                          setDateRangeCheck("2");
                        }}
                        className="h-4 w-4 border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                      />
                    </div>
                    <div className="ml-3 text-sm leading-2 grid grid-cols-12">
                      <div className="col-span-8">
                          Indefinitely into the future
                      </div>
                    </div>
                  </div>
              </div>
            </fieldset>  
            <div className="col-span-1"></div>
            <div className="relative mt-6 col-span-3 max-sm:col-span-12 text-gray-400">
              Define how long invitees can schedule event.
            </div>  
          </div>  
          <div className="font-bold mt-6">Meeting duration</div>  
          <div className="mt-3 grid grid-cols-9">
            <Listbox as="div" className="col-span-3 max-sm:col-span-12" value={durationData} onChange={setDurationData}>
              {({ open }) => (
                <>
                  <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">Duration</Listbox.Label>
                  <div className="relative mt-2">
                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                      <span className="block truncate">{durationData?.name}</span>
                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </span>
                    </Listbox.Button>

                    <Transition
                      show={open}
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {filteredDuration.map((duration) => (
                          <Listbox.Option
                            key={duration.id}
                            className={({ active }) =>
                              classNames(
                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                'relative cursor-default select-none py-2 pl-3 pr-9'
                              )
                            }
                            value={duration}
                          >
                            {({ selected, active }) => (
                              <>
                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                  {duration.name}
                                </span>

                                {selected ? (
                                  <span
                                    className={classNames(
                                      active ? 'text-white' : 'text-[var(--brand-primary)]',
                                      'absolute inset-y-0 right-0 flex items-center pr-4'
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>    
            <div className="col-span-1"></div>
            <div className="relative mt-6 col-span-3 max-sm:col-span-12 text-gray-400">
              Define how long your event will be. It can be as long as 12 hours.
            </div>
          </div>
          <div className="mt-8 font-bold">
            Want to add time before or after our events?
          </div>
          <div className="mt-3 grid grid-cols-9">
            <Listbox as="div" className="col-span-3 max-sm:col-span-12" value={beforeTime} onChange={setBeforeTime}>
              {({ open }) => (
                <>
                  <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">Before Event</Listbox.Label>
                  <div className="relative mt-2">
                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                      <span className="block truncate">{beforeTime?.name}</span>
                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </span>
                    </Listbox.Button>

                    <Transition
                      show={open}
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {filteredBeforeAfterTime?.map((duration) => (
                          <Listbox.Option
                            key={duration.id}
                            className={({ active }) =>
                              classNames(
                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                'relative cursor-default select-none py-2 pl-3 pr-9'
                              )
                            }
                            value={duration}
                          >
                            {({ selected, active }) => (
                              <>
                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                  {duration.name}
                                </span>

                                {selected ? (
                                  <span
                                    className={classNames(
                                      active ? 'text-white' : 'text-[var(--brand-primary)]',
                                      'absolute inset-y-0 right-0 flex items-center pr-4'
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>    
            <div className="col-span-1"></div>
            <div className="relative mt-6 col-span-3 max-sm:col-span-12 text-gray-400">
              Give yourself some buffer time to prepare for or wrap up from booked
              ZOI Calender events.
            </div>
          </div>
          <div className="mt-3 grid grid-cols-9">
            <Listbox as="div" className="col-span-3 max-sm:col-span-12" value={afterTime} onChange={setAfterTime}>
              {({ open }) => (
                <>
                  <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">After Event</Listbox.Label>
                  <div className="relative mt-2">
                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                      <span className="block truncate">{afterTime?.name}</span>
                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </span>
                    </Listbox.Button>

                    <Transition
                      show={open}
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {filteredBeforeAfterTime?.map((duration) => (
                          <Listbox.Option
                            key={duration.id}
                            className={({ active }) =>
                              classNames(
                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                'relative cursor-default select-none py-2 pl-3 pr-9'
                              )
                            }
                            value={duration}
                          >
                            {({ selected, active }) => (
                              <>
                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                  {duration.name}
                                </span>

                                {selected ? (
                                  <span
                                    className={classNames(
                                      active ? 'text-white' : 'text-[var(--brand-primary)]',
                                      'absolute inset-y-0 right-0 flex items-center pr-4'
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>     
            <div className="col-span-1"></div>
            <div className="relative mt-6 col-span-3 max-sm:col-span-12 text-gray-400">
              Give yourself some buffer time to prepare for or wrap up from booked
              ZOI Calender events.
            </div>
          </div>
          <div className="mt-8 font-bold">Start time increments</div>
          <div className="mt-3 grid grid-cols-9">
            <Listbox as="div" className="col-span-3 max-sm:col-span-12" value={incrementTime} onChange={setIncrementTime}>
              {({ open }) => (
                <>
                  <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">Show available start times in increments of...</Listbox.Label>
                  <div className="relative mt-2">
                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                      <span className="block truncate">{incrementTime?.name}</span>
                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </span>
                    </Listbox.Button>

                    <Transition
                      show={open}
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {filteredStartIncrement?.map((duration) => (
                          <Listbox.Option
                            key={duration.id}
                            className={({ active }) =>
                              classNames(
                                active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                'relative cursor-default select-none py-2 pl-3 pr-9'
                              )
                            }
                            value={duration}
                          >
                            {({ selected, active }) => (
                              <>
                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                  {duration.name}
                                </span>

                                {selected ? (
                                  <span
                                    className={classNames(
                                      active ? 'text-white' : 'text-[var(--brand-primary)]',
                                      'absolute inset-y-0 right-0 flex items-center pr-4'
                                    )}
                                  >
                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>    
            <div className="col-span-1"></div>
            <div className="relative mt-6 col-span-3 max-sm:col-span-12 text-gray-400">
              Set the frequency of available time slots for invitees.
            </div>
          </div>
            
          <div className="mt-8 font-bold">Available Schedules</div>
            <div className="mt-3 grid grid-cols-9">
              <Listbox as="div" className="col-span-3 max-sm:col-span-12" value={scheduleData} onChange={setScheduleData}>
                {({ open }) => (
                  <>
                    <Listbox.Label className="block text-sm font-medium leading-6 text-gray-900">Show available schedules</Listbox.Label>
                    <div className="relative mt-2">
                      <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                        <span className="block truncate">{scheduleData?.schedule_name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                      </Listbox.Button>

                      <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                          {filteredScheduleList?.map((schedule) => (
                            <Listbox.Option
                              key={schedule.schedule_id}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                  'relative cursor-default select-none py-2 pl-3 pr-9'
                                )
                              }
                              value={schedule}
                            >
                              {({ selected, active }) => (
                                <>
                                  <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                    {schedule.schedule_name}
                                  </span>

                                  {selected ? (
                                    <span
                                      className={classNames(
                                        active ? 'text-white' : 'text-[var(--brand-primary)]',
                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                      )}
                                    >
                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                    </span>
                                  ) : null}
                                </>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            <div className="col-span-1"></div>
            <div className="relative mt-6 col-span-3 max-sm:col-span-12 text-gray-400">
              Set repeating times or date-specific overrides for the free time Calendly will offer on your calendar.
            </div>
          </div>
            
          <div className="mt-8 font-bold">Scheduling conditions</div>
          <div className="block text-sm font-medium leading-6 text-gray-900 mt-3">
            Invitees can't schedule Within...
          </div>
          <div className=" grid grid-cols-9">
            <div className="mt-2 max-sm:col-span-3 col-span-1 mr-4">
              <input
                type="text"
                name="time"
                id="time"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                placeholder="0 - 300"
                value={scheduleTimeLimitInput}
                onChange={(e) => {
                  if ((e.target.value > 0 && e.target.value < 301) || e.target.value === "") {
                    setScheduleTimeLimitInput(e?.target?.value);
                  }
                }}
                min="1"
                max="6"
              />
            </div>
            <Listbox as="div" className="col-span-2 max-sm:col-span-8" value={scheduleTimeLimit} onChange={setScheduleTimeLimit}>
                {({ open }) => (
                  <>
                    <div className="relative mt-2">
                      <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                        <span className="block truncate">{scheduleTimeLimit?.name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                      </Listbox.Button>

                      <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                          {filteredScheduleWithin?.map((duration) => (
                            <Listbox.Option
                              key={duration.id}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                  'relative cursor-default select-none py-2 pl-3 pr-9'
                                )
                              }
                              value={duration}
                            >
                              {({ selected, active }) => (
                                <>
                                  <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                    {duration.name}
                                  </span>

                                  {selected ? (
                                    <span
                                      className={classNames(
                                        active ? 'text-white' : 'text-[var(--brand-primary)]',
                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                      )}
                                    >
                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                    </span>
                                  ) : null}
                                </>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
            </Listbox>  
            <div className="col-span-1"></div>
            <div className="relative mt-2 max-sm:col-span-12 col-span-3 text-gray-400">
              Set the minimum amount of notice that is required and how many events
              are allowed per day.
            </div>
          </div>
          {/* <div className="block text-sm font-medium leading-6 text-gray-900 mt-3">
          Maximum allowed events per day for this type of event
          </div>
          <div className=" grid grid-cols-9">
            <div className="mt-2 col-span-1 max-sm:col-span-3 mr-4">
              <input
                type="number"
                name="time"
                id="time"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#49BCD2] sm:text-sm sm:leading-6"
                value={allowedEvent}
                onChange={(e) => {
                  if((e.target.value > 0 && e.target.value < 7) || e.target.value === "")
                  setAllowedEvent(e?.target?.value)
                }}
                min="1"
                max="6"
                placeholder="1 - 6"
              />
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingEvents;
